import { buildQueryString } from '../helpers/Utils';

export default class Users {
  constructor(api) {
    this.api = api;
  }

  changePassword(req) {
    const { password, confirmPassword, currentPassword } = req;
    return this.api.fetch('/api/users/change-password', {
      method: 'PUT',
      body: JSON.stringify({ password, currentPassword, confirmPassword }),
    });
  }

  createOrUpdate(user) {
    console.log({ user });
    const method = user.id ? 'PUT' : 'POST';
    return new Promise((resolve, reject) => {
      this.api
        .fetch('/api/users/update', {
          method,
          credentials: 'include',
          body: JSON.stringify(user),
          headers: {
            Accept:
              'application/json, application/xml, text/plain, text/html, *.*',
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          resolve(res.json());
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  list(query) {
    query = query || {};
    const queryString = buildQueryString(query);

    return this.api.fetchJson('/api/users/list' + queryString);
  }

  notificationToken(token) {
    return this.api.fetch('/api/users/notification-token', {
      method: 'POST',
      body: JSON.stringify({
        token,
      }),
    });
  }

  me() {
    //TODO hit endpoint
  }
}
